/**
 * @sort kardex_date
 */
export default [
    {
        text: 'producto',
        value: 'product_name',
        width: '250px',
        component: {
            custom: 'wh_product_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    //{
    //    text: 'fecha',
    //    value: 'kardex_date',
    //    sortable: true,
    //    format: 'date',
    //    width: '125px',
    //},
    {
        text: 'cantidad entrada',
        value: 'ini_in_quantity',
        align: 'right',
        format: 'number',
    },
    {
        text: 'precio entrada',
        value: 'ini_in_unit_cost',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'valor entrada',
        value: 'ini_in_cost',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'cantidad salida',
        value: 'out_out_quantity',
        align: 'right',
        format: 'number',
    },
    {
        text: 'precio salida',
        value: 'out_out_unit_cost',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'valor salida',
        value: 'out_out_cost',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'cantidad inventario',
        value: 'inventory_inventory_quantity',
        align: 'right',
        format: 'number',
    },
    {
        text: 'precio inventario',
        value: 'inventory_inventory_unit_cost',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'saldo inventario',
        value: 'inventory_inventory_balance_cost',
        align: 'right',
        format: 'currency',
    },
]
